export default "/images/58c533b89365f6d9b63f0cbd4870e625.avif";